import React, {forwardRef} from 'react';
import {TextInput} from 'react-native';
import {useSuppressedInputRef} from '../../hooks/useKeyboardSuppression';

const ScanTextInput = forwardRef((props, ref) => {
  const {setRef, suppressionProps} = useSuppressedInputRef(ref);
  return <TextInput ref={setRef} {...props} {...suppressionProps} />;
});

export default ScanTextInput;
